(() => {
  const selector = '.m-product-card__media,.by-story-card__media,.m-cascading-product-card__image,.m-search-item--image,.m-lookbook-product__thumb,.byes-complete-look__media,.byh-card,.by-swipe-card__media,.by-swipe-result-card__image,.by-look__card-media';
  const label = document.querySelector('script[data-by-new-card-label]')?.dataset.byNewCardLabel;
  if (!label) return;
  let membership;
  let scheduled = false;
  const pending = new Set();

  async function loadMembership() {
    const ids = new Set();
    const handles = new Set();
    let page = 1;
    while (page) {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'collections/new-arrivals', location.origin);
      url.searchParams.set('view', 'by-new-card-membership');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-cache' });
      if (!response.ok) throw new Error('New Arrivals membership unavailable');
      const data = JSON.parse(await response.text());
      if (!Array.isArray(data.products)) throw new Error('Invalid New Arrivals membership');
      data.products.forEach(product => {
        ids.add(String(product.id));
        handles.add(product.handle);
      });
      const next = Number(data.next_page);
      page = Number.isInteger(next) && next > page ? next : 0;
    }
    return { ids, handles };
  }

  function productKey(media) {
    const card = media.closest('[data-look-product],.m-product-card,.byes-complete-look__card,.by-swipe-card,.by-swipe-result-card,.by-wishlist-fallback-card,.by-story-card') || media;
    const id = card.dataset.lookProduct || card.dataset.productId;
    const link = media.matches('a[href]') ? media : card.querySelector('a[href*="/products/"]');
    const match = link && new URL(link.href, location.origin).pathname.match(/\/products\/([^/]+)/);
    return { id, handle: match ? decodeURIComponent(match[1]) : '' };
  }

  async function flush() {
    scheduled = false;
    const items = [...pending];
    pending.clear();
    if (!items.length) return;
    try {
      membership ||= loadMembership();
      const { ids, handles } = await membership;
      items.forEach(media => {
        if (!media.isConnected) return;
        const product = productKey(media);
        if (!product.id && !product.handle) return;
        const eligible = ids.has(String(product.id)) || handles.has(product.handle);
        const existing = media.querySelector(':scope > [data-by-new-card-stamp]');
        if (!eligible) {
          existing?.remove();
          return;
        }
        if (existing) return;
        const badge = document.createElement('span');
        badge.className = 'by-new-card-stamp' + (media.matches('.m-search-item--image,.m-lookbook-product__thumb') ? ' by-new-card-stamp--compact' : '');
        badge.dataset.byNewCardStamp = '';
        const star = document.createElement('span');
        star.setAttribute('aria-hidden', 'true');
        star.textContent = '✦';
        badge.append(star, document.createTextNode(label));
        media.appendChild(badge);
      });
    } catch {
      membership = undefined;
    }
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.(selector)) pending.add(node);
    node.querySelectorAll(selector).forEach(media => pending.add(media));
    if (pending.size && !scheduled) {
      scheduled = true;
      queueMicrotask(flush);
    }
  }

  function refresh() {
    membership = undefined;
    scan(document);
  }

  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
})();

